import { useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";
import { useT } from "../lib/i18n";

export function PaymentLinksModal({ sale, onClose }) {
  const { t } = useT();
  const [links, setLinks] = useState([]);
  const load = () => api.get(`/sales/${sale.id}/payment-links`).then((r) => setLinks(r.data.items)).catch((e) => toast.error(formatApiError(e)));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [sale.id]);
  const full = (p) => `${window.location.origin}${p}`;
  const create = async () => {
    try {
      const { data } = await api.post(`/sales/${sale.id}/payment-links`);
      await navigator.clipboard?.writeText(full(data.path)).catch(() => {});
      toast.success(t("pl.created"));
      load();
    } catch (e) { toast.error(formatApiError(e)); }
  };
  const revoke = async (id) => {
    try { await api.post(`/payment-links/${id}/revoke`); toast.success(t("pl.revoked")); load(); } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onClick={onClose}>
      <div className="panel p-6 max-w-lg w-full max-h-[85vh] overflow-y-auto" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" data-testid="payment-links-modal">
        <div className="eyebrow mb-1">{t("pl.title")}</div>
        <div className="text-sm mb-4">{sale.reference} · {sale.buyer_name}</div>
        <button className="btn-primary mb-4" onClick={create} autoFocus data-testid="create-payment-link">{t("pl.create")}</button>
        <div className="space-y-2">
          {links.map((l) => (
            <div key={l.id} className="border rounded-lg p-3 text-xs space-y-1" data-testid={`payment-link-${l.id}`}>
              <div className="flex justify-between gap-2"><span className="font-semibold">{t(`pl.st_${l.status /* i18n-keys: active,revoked,expired,used */}`)}</span><span>{t("pl.expires", { d: l.expires_at.slice(0, 10) })}</span></div>
              {l.status === "active" && (
                <>
                  <input readOnly value={full(l.path)} dir="ltr" aria-label={t("pl.title")} className="w-full h-9 rounded border px-2 mono" onFocus={(e) => e.target.select()} data-testid={`payment-link-url-${l.id}`} />
                  <button className="text-red-600 font-semibold min-h-[44px]" onClick={() => revoke(l.id)} data-testid={`revoke-link-${l.id}`}>{t("pl.revoke")}</button>
                </>
              )}
            </div>
          ))}
          {links.length === 0 && <div className="text-xs text-[var(--gray-400)]">{t("pl.none")}</div>}
        </div>
        <div className="flex justify-end mt-4"><button className="btn-secondary" onClick={onClose} data-testid="close-payment-links">{t("pl.close")}</button></div>
      </div>
    </div>
  );
}
